import logoDefault from "./logos/logo_default.png"
const getLogo=()=>{
    const img = localStorage.getItem("logo")?.trim()
    return img ? img : logoDefault
}

const LOGO =getLogo()
export {LOGO}
